/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpPromise, IHttpService} from 'angular';

export class MigrationRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API'];
    /* @ngInject */
    constructor($http: IHttpService, REST_API: string) {
        this.serviceURL = REST_API + 'migration';
        this.http = $http;
    }

    public getServiceName(): string {
        return 'MigrationRS';
    }

    public importSchadenfaelle(): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/import/schadenfaelle');
    }

    public importGemeinden(): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/import/gemeinden');
    }

    public importPersonen(): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/import/personen');
    }

    public importGesuchsteller(personId: string): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/import/person/' + encodeURIComponent(personId));
    }

    public importBeitragForSchadenfall(schadenId: string): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/import/beitraege/' + encodeURIComponent(schadenId));
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/service/MigrationRS.rest.ts